export const notifications = (baseUrl: string, page?: number, size?: number): string =>
  `${baseUrl}/notifications/v1/notifications${page !== null && size !== null ? `?page=${page}&size=${size}` : ''}`;

export const hideNotification = (baseUrl: string, notificationId: string): string =>
  `${baseUrl}/notifications/v1/notifications/hide/${notificationId}`;

export const hideAllNotifications = (baseUrl: string): string => `${baseUrl}/notifications/v1/notifications/hideAll`;
